<template>
  <div>
    <div v-if="!editShow">
      {{ row.allocationWeight
      }}<i
        :class="$style.click"
        class="el-icon-edit"
        v-show="canEdit"
        @click="edit"
        v-per="editPermission"
      ></i>
    </div>
    <div :class="$style.edit" v-else>
      <el-input-number
        size="mini"
        v-model="value"
        controls-position="right"
        :min="0"
        :max="3"
        :step="0.1"
        step-strictly
        :controls="false"
      ></el-input-number>

      <i :class="$style.click" class="el-icon-check" @click="submit"></i>
      <i
        :class="$style.click"
        class="el-icon-close"
        @click="editShow = false"
      ></i>
    </div>
  </div>
</template>

<script>
import { setWeightSet } from "./api";
import { getBasicInfo } from "@/modules/user";
import { ROLE } from "@/modules/entities";
export default {
  name: "AllocationWeight",
  props: {
    row: { type: Object },
    item: {
      type: Object,
    },
    editPermission: [String, Number]
  },
  data() {
    return {
      editShow: false,
      value: "",
      loading: false,
    };
  },
  computed: {
    canEdit() {
      if (
        getBasicInfo().role === ROLE.BACK_DIRECTOR &&
        this.row.id !== getBasicInfo().depId
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    edit() {
      this.editShow = true;
      this.value = this.row.allocationWeight;
    },
    async submit() {
      if (this.loading) return;
      let confirm = await this.$confirm("是否修改权重?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (confirm !== "confirm") return;
      this.loading = true;
      let req = await setWeightSet({
        allocation_weight: this.value,
        group_id: this.row.id,
        queue_id: this.item.queue_id,
      });
      let { code, msg } = await req.json();
      this.loading = false;
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      this.$message.success("修改成功");
      this.editShow = false;
      this.$emit("callback");
    },
  },
};
</script>

<style style="scss" module>
.click {
  cursor: pointer;
}
.edit {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>